import React from 'react';
import { SectionWrapper } from './SectionWrapper';
export function StoryHook() {
  return <SectionWrapper bgColor="cream" data-id="element-274">
      <div className="font-sans text-lg text-gray-800 space-y-4 leading-relaxed" data-id="element-275">
        <p data-id="element-276">Eran las 6:47 de la mañana.</p>

        <p data-id="element-277">
          Me paré frente al espejo del baño, todavía en pijama, y me quedé
          mirando mi abdomen.
        </p>

        <p data-id="element-278">
          No había comido nada en 10 horas. Había dormido 7 horas. Me había ido
          a la cama "siendo buena" con mi alimentación.
        </p>

        <p data-id="element-279">
          Y aun así... el vientre seguía ahí. Abultado. Pesado. Como si mi
          cuerpo me estuviera jugando una broma cruel cada mañana.
        </p>

        <p data-id="element-280">Lo que sentí en ese momento no fue solo frustración.</p>

        <p className="font-serif text-xl md:text-2xl italic text-primary font-medium leading-snug my-5 border-l-4 border-accent pl-4" data-id="element-281">
          Fue algo más profundo. Fue la sensación de que mi propio cuerpo me
          había traicionado. Que no importaba cuánto me esforzara, cuánto me
          sacrificara, cuánto lo intentara — el resultado era siempre el mismo.
        </p>

        <p data-id="element-282">¿Te ha pasado eso?</p>

        <p data-id="element-283">Si estás leyendo esto, apuesto a que sí.</p>

        <p data-id="element-284">Y quiero que sepas algo importante antes de seguir:</p>

        <p className="font-bold text-xl text-dark" data-id="element-285">
          No es tu culpa. Y tiene solución.
        </p>
      </div>
    </SectionWrapper>;
}